import React, { useState } from 'react';
import { Grid, makeStyles, TextField } from '@material-ui/core';

const useStyles = makeStyles((theme)=>({
    nav:{
        display:'flex',
        flexDirection:'row',
        listStyleType:'none',
        color:'#b2bec3',
        marginBlockStart:'0em',
        padding:'1em',
        fontSize:'18px',
        fontWeight:'500',
        backgroundColor:'#2c3e50',
        position:'fixed',
        zIndex:1,
        width:'100vw',
        '@media (max-width: 768px)':{
            fontSize: '14px'
        }
    },
    anchor:{
        textDecoration:'none',
        color:'#ffff',
    }
}))

export default function Header(props){
    const classes = useStyles();

    function MouseOver(event){
        event.target.style.textDecoration="underline"
        event.target.style.paddingBottom="1em"
    }
    function MouseOut(event){
        event.target.style.textDecoration="none"
    }
    return(
        <React.Fragment>
        <div >
            <ul className={classes.nav}>
                <li style={{
                    marginRight:'3em',
                    backgroundColor:'blue',
                    padding:'1em',
                }}>
                    <a href="/#section1" className={classes.anchor}>
                        About
                    </a>
                </li>
                <li onMouseOver={MouseOver} onMouseOut={MouseOut} style={{marginRight:'4em',padding:'1em'}}>
                    <a href="/#section2" className={classes.anchor}>
                        My Work
                    </a>
                </li>
                <li onMouseOver={MouseOver} onMouseOut={MouseOut} style={{marginRight:'4em',padding:'1em'}}>
                    <a href="/#section3" className={classes.anchor}>
                        Skills & Languages
                    </a>
                </li>
                <li style={{marginRight:'4em',padding:'1em'}}>
                    <a href="/#section4" className={classes.anchor}>
                        Contact
                    </a>
                </li>
            </ul>
        </div>
        </React.Fragment>
    )
}

